import { render } from "./PdpArchivedProductLink.vue?vue&type=template&id=077e2471"
import script from "./PdpArchivedProductLink.vue?vue&type=script&lang=js"
export * from "./PdpArchivedProductLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__